import { humanizeTime } from "@utils/common";
const EQUALS = "=".repeat(10);
export const MESSAGES = {
    apiWrapper: {
        requestFailed: (attemptNumber, retriesLeft, error) => `API request attempt ${attemptNumber} failed. ${retriesLeft} retries left. Error: ${error}`,
        allRetriesFailed: (error) => `API call failed after all retries: ${error}`,
    },
    heartbeat: {
        schedulingFailed: (error) => `Heartbeat scheduling failed: ${error}`,
        emergencyTriggered: "Emergency heartbeat triggered - no successful heartbeat in 100+ seconds",
        emergencyFailed: (error) => `Emergency heartbeat failed: ${error}`,
        failed: (error) => `Heartbeat failed: ${error}`,
        attemptFailed: (attemptNumber, retriesLeft, error) => `Heartbeat attempt ${attemptNumber} failed. ${retriesLeft} retries left. Error: ${error}`,
    },
    onBegin: {
        testData: (ciBuildId, shard) => {
            let message = `
-------Started reporting to NeetoPlaydash 🎭-------
CI Build ID: ${ciBuildId}\n`;
            shard
                ? (message += `Total shards: ${shard.total}\nCurrent shards: ${shard.current}\n`)
                : "";
            message += `${"-".repeat(50)}\n`;
            return message;
        },
    },
    onTestBegin: {
        startingTest: ({ titlePath, historyId, retry, repeatEachIndex, }) => `${EQUALS}Starting ${titlePath}${EQUALS}
    Time: ${new Date().toUTCString()}
    History ID: ${historyId}${retry ? `\nRetry: ${retry}` : ""}${repeatEachIndex ? `\nRepeat index: ${repeatEachIndex}` : ""}`,
    },
    onTestEnd: {
        reportedTest: ({ title, status, historyId, completedAt, error, isTestReported = true, retry, repeatEachIndex, }) => {
            let message = `\n
${isTestReported
                ? "------------Reported to NeetoPlaydash------------"
                : "-".repeat(49)}
    Title: ${title}
    History id: ${historyId}
    Status: ${status}
    Completed at: ${completedAt}${retry ? `\nRetry: ${retry}` : ""}${repeatEachIndex ? `\nRepeat index: ${repeatEachIndex}` : ""}
`;
            message = error
                ? message.concat(`    Error:\n\n ${error.replaceAll("\n", "\n    ")}`)
                : message;
            return message.concat(`\n${"-".repeat(49)}\n`);
        },
    },
    onEnd: {
        runReported: "Run completed and reported to NeetoPlaydash 🎉\n\n",
        finalStatus: ({ currentShard, status, duration, }) => {
            let message = `------------------Run completed-------------------
    Status: ${status}
    Duration: ${humanizeTime(duration !== null && duration !== void 0 ? duration : 0)}\n`;
            message =
                currentShard !== 0
                    ? message.concat(`    Shard: ${currentShard}`)
                    : message;
            return message.concat(`\n${"-".repeat(50)}\n`);
        },
        dashboardUrlHeader: "View the run in the dashboard",
    },
};
//# sourceMappingURL=messages.js.map